import url from 'url'
import { updateAppUrl } from 'lib/url/route'
import { urlQuery, slugifyPath } from 'lib/helpers'
import { DEFAULT_APP } from './constants'
import { getFirstFacetValue, removeUsedFacets } from './facets'
// We need a way to pull SPECIAL Query Params for ALGOLIA
// Ex: hitsPerPage, page, sort
export const getPageParamsQuery = (href: string = ''): Record<string, any> => {
  const { query } = url.parse(href, true)
  const { hitsPerPage, page, sort, width, height, query: search } = query || {}
  return {
    height,
    hitsPerPage,
    page,
    query: search,
    sort,
    width,
  }
}
// queryParams merged attributes to create url  => ...selectedFacets, ...algoliaQuery, ...dimensionQuery, ...params
// urlPathParams
// sharedFacetNames
export const generateLocationUrl = ({
  queryParams,
  pathParams,
  sharedFacetNames,
}: Record<string, any>): string => {
  const urlPathParams = pathParams.reduce(
    (results, facetName) => ({
      ...results,
      [facetName]: getFirstFacetValue(facetName, queryParams[facetName], {
        sharedFacetNames,
      }),
    }),
    {}
  )

  // Product Note -> restore URL rules for /prints instead of /prints/all
  if (urlPathParams.has_prints && urlPathParams.category === 'All') {
    delete urlPathParams.category
  }

  const pathString = slugifyPath(
    Object.values(urlPathParams)
      .filter(Boolean)
      .map(String)
  )
  const queryCleanup = removeUsedFacets({
    facets: queryParams,
    usedValues: { ...urlPathParams, has_prints: true }, // Never append `has_prints` to `?` query
  })
  const queryString = urlQuery(queryCleanup)
  return `${pathString}${queryString}`
}
export const updateBrowseUrl = (href: string): void => {
  updateAppUrl({
    app: DEFAULT_APP,
    href,
  })
}
